import { path } from 'ramda';

const gtag = (...params) => window.etp.analytics?.gtag(...params);

const trackAdWords = () =>
  gtag(
    'config',
    path(['etp', 'config', 'analytics', 'googleAdWordsPixelKey'], window),
    { page_path: window.location.pathname },
  );

export { gtag, trackAdWords };
